import type { DefaultTheme } from 'styled-components';
import type { MapInteractionTracking } from '../SchoolCatchmentMapBrick';
import { createRef } from 'react';
import { addGeoJson } from '../../../../../../app-kit/components/PcaMap/helpers/addGeoJson';
import { fitBoundsToGeoJson } from '../../../../../../app-kit/components/PcaMap/helpers/fitBoundsToGeoJson';
import { setStyles } from '../../../../../../app-kit/components/PcaMap/helpers/setStyles';
import { GeoJsonData, OnMapLoaded } from '../../../../../../app-kit/components/PcaMap/PcaMap';
import { addControlButtonsToTopRight } from '../../../../../../app-kit/components/PcaMap/subcomponent/helpers/addControlButtonsToMap';
import { trackFullscreenToggleOnce } from '../../../../../../analytics/event-tracking/map-tracking/trackFullscreenToggleOnce';
import { trackZoomLevelChangeOnce } from '../../../../../../analytics/event-tracking/map-tracking/trackZoomLevelChangeOnce';

export const onSchoolCatchmentMapLoaded = ({
  catchmentZones,
  tracking,
  controlButtonsRef = createRef(),
  theme,
}: {
  catchmentZones?: GeoJsonData | null;
  tracking?: MapInteractionTracking | null;
  controlButtonsRef?: React.MutableRefObject<HTMLDivElement | null>;
  theme: DefaultTheme;
}): OnMapLoaded => {
  return ({ google, map }) => {
    if (catchmentZones) {
      addGeoJson(map, catchmentZones, 'schoolCatchmentZone');
      setStyles(map, theme);
      fitBoundsToGeoJson({ map, geoJsonData: catchmentZones });
    }

    addControlButtonsToTopRight(map, controlButtonsRef);
    if (tracking) {
      google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
        trackFullscreenToggleOnce(map, tracking.toggleFullscreen);
        trackZoomLevelChangeOnce(google, map, tracking.changeZoomLevel);
      });
    }
  };
};
